// extracted by mini-css-extract-plugin
export default {"heading":"productBudget_heading__opjjo","subheading":"productBudget_subheading__WP246"};